export function getCityAndUfByRegex(value: string) {
	const cityUfRegex = /(?<city>[A-Za-zÀ-ÖØ-öø-ÿ\s]{1,50})\/(?<uf>[A-Za-z]{2})/;

	const fullRegex =
		/(?<district>[A-Za-zÀ-ÖØ-öø-ÿ\s]{1,100}) - (?<city>[A-Za-zÀ-ÖØ-öø-ÿ\s]{1,50})\/(?<uf>[A-Za-z]{2})/;

	let result = cityUfRegex.exec(value);

	if (result && result.groups) {
		const {city, uf} = result.groups;
		return {
			district: '',
			city,
			uf,
		};
	}

	result = fullRegex.exec(value);

	if (result && result.groups) {
		const {district, city, uf} = result.groups;
		return {
			district,
			city,
			uf,
		};
	}

	return {
		district: '',
		city: '',
		uf: '',
	};
}
